import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';

import A11yReport from 'umg-ember-backend/components/record-detail/forms/a11y-report';
import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:toolbar as |options|>
      <div class={{@controller.bem 'logo-wrapper'}}>
        <img
          src='assets/images/logo_accessify.svg'
          class={{@controller.bem 'logo' (hash is-compact=options.isCompact)}}
          alt={{t 'a11y_quickscan.logo_alt'}}
        />
      </div>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.quickscanOptions}}
        @showErrors={{@controller.showErrors}}
        class={{@controller.bem 'form'}}
        as |form|
      >
        <form.field
          @property='url'
          @label={{false}}
          @type='url'
          autocomplete='on'
          class={{@controller.bem 'field'}}
        />
        <Button
          @label={{if
            @controller.startScan.isRunning
            (t 'a11y_quickscan.scan_running')
            (t 'a11y_quickscan.scan_now')
          }}
          @disabled={{@controller.startScan.isRunning}}
          @icon='search'
          @type='submit'
          class={{@controller.bem 'button'}}
          {{on 'click' (perform @controller.startScan)}}
        />
      </Form>
    </:toolbar>
    <:body>
      <div class={{@controller.bem}}>
        <div class={{@controller.bem 'options'}}>

        </div>
        {{#if @controller.report}}
          <A11yReport @model={{@controller.report}} />
        {{else}}
          <div class={{@controller.bem 'no-report'}}>
            {{t 'a11y_quickscan.no_report'}}
          </div>
        {{/if}}
      </div>
    </:body>
  </Window>
</template>
